import { render, staticRenderFns } from "./MainDialog.vue?vue&type=template&id=4b47b376&scoped=true&"
import script from "./MainDialog.vue?vue&type=script&lang=js&"
export * from "./MainDialog.vue?vue&type=script&lang=js&"
import style0 from "./MainDialog.vue?vue&type=style&index=0&id=4b47b376&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b47b376",
  null
  
)

export default component.exports